var _path, _rect, _rect2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsername(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z",
    fill: "#285E61"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22.5,
    y: 22.5,
    width: 13,
    height: 13,
    rx: 6.5,
    fill: "#38A169"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22.5,
    y: 22.5,
    width: 13,
    height: 13,
    rx: 6.5,
    stroke: "white",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6648 11.2727H14.9858V17.0128C14.9858 17.6236 14.8423 18.1648 14.5554 18.6364C14.2685 19.1051 13.8651 19.4744 13.3452 19.7443C12.8253 20.0114 12.2159 20.1449 11.517 20.1449C10.821 20.1449 10.2131 20.0114 9.69318 19.7443C9.1733 19.4744 8.76989 19.1051 8.48295 18.6364C8.19602 18.1648 8.05256 17.6236 8.05256 17.0128V11.2727H9.36932V16.9062C9.36932 17.3011 9.45597 17.652 9.62926 17.9588C9.8054 18.2656 10.054 18.5071 10.375 18.6832C10.696 18.8565 11.0767 18.9432 11.517 18.9432C11.9602 18.9432 12.3423 18.8565 12.6634 18.6832C12.9872 18.5071 13.2344 18.2656 13.4048 17.9588C13.5781 17.652 13.6648 17.3011 13.6648 16.9062V11.2727ZM23.9442 11.2727V20H22.734L18.2979 13.5994H18.217V20H16.9002V11.2727H18.119L22.5593 17.6818H22.6403V11.2727H23.9442Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsername);
export default __webpack_public_path__ + "static/media/Username.dd9b30342fd6261c1191ee91fad08ba6.svg";
export { ForwardRef as ReactComponent };